import { default as SmsSender } from './SmsSender';

export { SmsSender };



// WEBPACK FOOTER //
// src/modules/screens/settings/SmsSender/components/index.js